import { Injectable } from '@angular/core';
import { Action } from '@ngrx/store';
import { Order, DeliveryStatus, Ticket } from "../../models";
import { UnsafeAction } from '../../actions/UnsafeAction';
import { OrderQuery } from '../../services/webservice/order-api.service';

/* tslint:disable */
@Injectable()
export class OrderActions {

	static GET_ORDER_BY_UUID = "[ORDER] get Order by UUID";
	public getOrderByUuid(uuid: string): UnsafeAction {
		return {
			type: OrderActions.GET_ORDER_BY_UUID,
			payload: uuid
		}
	}

	static GET_ORDER_BY_UUID_SUCCESS = "[ORDER] get Order by UUID success";
	public getOrderByUuidSuccess(order: Order) {
		return {
			type: OrderActions.GET_ORDER_BY_UUID_SUCCESS,
			payload: order
		}
	}

	static GET_DELIVERY_STATUS = "[ORDER] get DeliveryStatus";
	public getDeliveryStatus(secureId: string) {
		return {
			type: OrderActions.GET_DELIVERY_STATUS,
			payload: secureId
		}
	}

	static GET_DELIVERY_STATUS_SUCCESS = "[ORDER] get DeliveryStatus success";
	public getDeliveryStatusSuccess(deliveryStatus: DeliveryStatus) {
		return {
			type: OrderActions.GET_DELIVERY_STATUS_SUCCESS,
			payload: deliveryStatus
		}
	}

	static GET_TICKETS = "[ORDER] get Tickets";
	public getTickets(orderUuid: string): UnsafeAction {
		return {
			type: OrderActions.GET_TICKETS,
			payload: orderUuid
		}
	}

	static GET_TICKETS_SUCCESS = "[ORDER] get Tickets success";
	public getTicketsSuccess(tickets: Ticket[]): UnsafeAction {
		return {
			type: OrderActions.GET_TICKETS_SUCCESS,
			payload: tickets
		}
	}

	static ORDER_SEARCH = "[ORDER] order query"
	public orderSearch(query: OrderQuery): UnsafeAction {
		return {
			type: OrderActions.ORDER_SEARCH,
			payload: query
		}
	}

	static ORDER_SEARCH_SUCCESS = "[ORDER] order query success"
	public orderSearchSuccess(orders): UnsafeAction{
		return {
			type: OrderActions.ORDER_SEARCH_SUCCESS,
			payload: orders
		}
	}

	static PRINT_TICKETS = "[ORDER] print tickets"
	public printTickets(ticketUUIDs): UnsafeAction{
		return {
			type: OrderActions.PRINT_TICKETS,
			payload: ticketUUIDs
		}
	}

	static PRINT_PDF_TICKET = "[ORDER] print pdf ticket"
	public printPdfTicket(ticketUUID): UnsafeAction{
		return {
			type: OrderActions.PRINT_PDF_TICKET,
			payload: ticketUUID
		}
	}

	static SEND_EMAIL = "[ORDER] sendEmail"
	public sendEmail(altEmail): UnsafeAction{
		return {
			type: OrderActions.SEND_EMAIL,
			payload: altEmail
		}
	}
	static REMOVE_PRINT_SPINNER = "[ORDER] remove print spinner"
	public removePrintSpinner(): UnsafeAction {
		return {
			type: OrderActions.REMOVE_PRINT_SPINNER,
			payload: null,
		}
	}

	static COMPLETE_ORDER = "[ORDER] completeOrder"
	public completeOrder(orderUUID, sendEmail): UnsafeAction {
		return {
			type: OrderActions.COMPLETE_ORDER,
			payload: { uuid: orderUUID, sendEmail: sendEmail },
		}
	}

	static SEND_ORDER_COMPLETION_MAIL = "[ORDER] send OrderCompletionMail"
	public sendOrderCompletionMail(orderUUID): UnsafeAction {
		return {
			type: OrderActions.SEND_ORDER_COMPLETION_MAIL,
			payload: { uuid: orderUUID },
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/components/order-components/order.actions.ts